import React from 'react';

const ProfileFilledIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M9.99996 1.66675C5.41663 1.66675 1.66663 5.41675 1.66663 10.0001C1.66663 14.5834 5.41663 18.3334 9.99996 18.3334C14.5833 18.3334 18.3333 14.5834 18.3333 10.0001C18.3333 5.41675 14.5833 1.66675 9.99996 1.66675ZM9.99996 5.41675C11.4166 5.41675 12.5 6.50008 12.5 7.91675C12.5 9.33342 11.4166 10.4167 9.99996 10.4167C8.58329 10.4167 7.49996 9.33342 7.49996 7.91675C7.49996 6.50008 8.58329 5.41675 9.99996 5.41675ZM9.99996 16.6667C8.16663 16.6667 6.49996 15.9167 5.33329 14.7501C6.24996 13.1667 7.99996 12.0834 9.99996 12.0834C12 12.0834 13.75 13.1667 14.6666 14.7501C13.5 15.9167 11.8333 16.6667 9.99996 16.6667Z' />
		</svg>
	);
};

export default ProfileFilledIcon;
